import {generateTaskPathForRepo} from '@github-ui/agent-sessions/utils/generate-task-path'

/**
 * The current page origin (e.g. `https://github.com`) when running in the
 * browser, or an empty string during SSR/tests. Used to turn the root-relative
 * task paths into full URLs we can show the user.
 */
export function currentOrigin(): string {
  return typeof window !== 'undefined' ? window.location.origin : ''
}

/** Prepend `origin` to a root-relative path, yielding a full URL when possible. */
export function toAbsoluteUrl(path: string, origin: string): string {
  if (!path) return path
  return origin && path.startsWith('/') ? `${origin}${path}` : path
}

/** Root-relative path a cloud agent session (task) lives at. */
export function sessionPath(taskId: string, nwo?: string): string {
  return generateTaskPathForRepo({taskId, ...(nwo ? {repositoryNwo: nwo} : {})})
}

/** Full, openable URL for a cloud agent session, given the page origin. */
export function sessionUrl(taskId: string, origin: string, nwo?: string): string {
  return toAbsoluteUrl(sessionPath(taskId, nwo), origin)
}
